import React, { useCallback, useEffect, useRef } from "react";
import { initializePaddle } from "@paddle/paddle-js";
import { Button, message } from "antd";
import { CreditCardOutlined } from "@ant-design/icons";
import { PADDLE_CLIENT_TOKEN } from "../../../../config";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../../store/user/selectors";
import { setKeyValue } from "../../../../store/user/slice";
import { useSearchParams } from "react-router-dom";

const PaddleCheckout = ({
  selectedPlan,
  perMemberPrice,
  teamMembers,
  closeModal = null,
}) => {
  const [searchParams] = useSearchParams();
  const tenant_id = searchParams.get("tenant_id");
  const paddleRef = useRef(null);
  const user = useSelector(selectUser);
  const checkOutContainerRef = useRef(null);
  const pricesRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    pricesRef.current = {
      [selectedPlan?.price?.id]: selectedPlan?.price,
      [perMemberPrice?.price?.id]: perMemberPrice?.price,
    };
  }, [selectedPlan, perMemberPrice]);

  useEffect(() => {
    const initPaddle = async () => {
      const paddle = await initializePaddle({
        environment: "production",
        token: PADDLE_CLIENT_TOKEN,

        eventCallback: async (event) => {
          if (event.name === "checkout.completed") {
            message.success("Payment Successful");

            await new Promise((resolve) => setTimeout(resolve, 2000));

            window.location.reload();

            paddleRef.current?.Checkout.close();

            checkOutContainerRef.current.style.display = "none";

            dispatch(
              setKeyValue({
                key: "currentPlan",
                value: {
                  ...event.data,
                  items: event.data.items.map((i) => ({
                    ...i,
                    price: pricesRef.current[i.price_id],
                  })),
                },
              }),
            );

            if (closeModal) closeModal();
          }
        },
      });

      paddleRef.current = paddle;
    };

    initPaddle();
  }, []);

  const openCheckout = useCallback(async () => {
    if (!paddleRef) return;
    try {
      checkOutContainerRef.current.style.display = "block";

      const payload = {
        items: [
          {
            priceId: selectedPlan?.price?.id,
            quantity: 1,
          },
          ...(teamMembers > 0
            ? [
                {
                  priceId: perMemberPrice?.price?.id,
                  quantity: teamMembers,
                },
              ]
            : []),
        ],
        customData: {
          tenant_id,
          tenant_owner_id: user?.user_id,
        },
        customer: {
          email: user?.email,
        },
        settings: {
          displayMode: "inline",
          frameTarget: "checkout-container",
          frameInitialHeight: 600,
          variant: "one-page",
          showAddDiscounts: true,
        },
      };

      paddleRef.current.Checkout.open(payload);
    } catch (error) {
      console.log("🚀 ~ PaddleCheckout.jsx: ~ PaddleCheckout ~ error:", error);
    }
  }, [paddleRef, selectedPlan, perMemberPrice, teamMembers, tenant_id, user]);

  return (
    <div className="w-100 flex justify-end">
      <div className="checkout-container" ref={checkOutContainerRef} />
      <Button
        onClick={openCheckout}
        type="primary"
        icon={<CreditCardOutlined />}
      >
        Checkout
      </Button>
    </div>
  );
};

export default PaddleCheckout;
